module.exports = (__webpack_require__(24))(638);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/create-react-class/index.js from dll-reference lib_core
// module id = 850
// module chunks = 110